(ns quuppa.qsm.cors.events
  (:require [re-frame.core :as rf :refer [reg-event-fx]]
            [quuppa.peweb.query :as q]))

(def cors-origins-query (q/create-query :cors/list-origins [:qpe-identity]))

(rf/reg-event-db
  :cors/add-origin
  (q/update-event-fn cors-origins-query
                     (fn [result event]
                       (if (some #(= (:id %) (:id (:origin event))) result)
                         result
                         (conj result (:origin event))))))

(rf/reg-event-db
  :cors/remove-origin
  (q/update-event-fn cors-origins-query
                     (fn [result event]
                       (into (empty result)
                             (remove #(= (:id %) (:id event)) result)))))

(reg-event-fx
  :cors/create-origin
  (fn [_ [_ qpe-identity form]]
    {:fx [[:server-dispatch {:event [:cors/create-origin (merge {:comment ""
                                                                 :origin ""}
                                                                (assoc form :qpe-identity qpe-identity))]
                             :on-success [::origin-added qpe-identity]
                             :on-error [::origin-added-error qpe-identity]}]]}))

;; TODO: Bad naming, had to avoid conflict with another :cors/remove-origin event...
(reg-event-fx
  :cors/remove-origin-command
  (fn [_ [_ _qpe-identity id]]
    {:fx [[:server-dispatch {:event [:cors/remove-origin {:id id}]}]]}))


(rf/reg-event-fx
  ::origin-added
  (fn [{:keys [db]} [_ qpe-identity]]
    {:db (update-in db [:qpes qpe-identity :ui] dissoc :sidebar)}))

(rf/reg-event-fx
  ::origin-added-error
  (fn [{:keys [db]} [_ qpe-identity error]]
    {:db (assoc-in db [:qpes qpe-identity :ui :sidebar :error] error)}))
